const paymentTermScheme = '/Payment-Terms-Scheme';

export { paymentTermScheme };
